import { createAction } from "@reduxjs/toolkit";

export const setHighlightError = createAction<string | null>(
  "highlight/setError",
);
